import {useEffect} from 'react';
import {ELEMENT_CLASSNAME} from '../utils/consts';
import {WidgetSvg} from './types';

const useElementHighlights = (
	svgRootObj: WidgetSvg | undefined,
	setSelectedAssetId: (arg0: number) => void,
	selectedAssetId?: number
) => {
	useEffect(() => {
		if (svgRootObj) {
			// add mouseover handlers to all elements and remove all markers since sometimes the config leaves some behind
			const elementsToDemark = svgRootObj.select(`g.${ELEMENT_CLASSNAME}`);
			elementsToDemark?.members.forEach((element) => {
				const assetId: number = parseInt(element.attr('id').replace('added_device_', ''));
				element.mouseover(() => {
					setSelectedAssetId(assetId);
				});
				element.touchstart(() => {
					setSelectedAssetId(assetId);
				});
				const marker = element.select(`rect#marker`)?.members[0];
				if (marker) {
					marker.node.style.visibility = assetId === selectedAssetId ? 'visible' : 'hidden';
				}
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [svgRootObj, selectedAssetId]);
};

export default useElementHighlights;
